import { API_REQUEST } from ".";
import {
  signUpAPI,
  loginAPI,
  varifyOtpAPI,
  forgotPasswordAPI,
  varifyForgotOtpAPI,
  resetCurrentPasswordAPI,
  resendOtpAPI,
  subscriptionsAPI,
  editProfileAPI,
  profileAPI,
  faqAPI,
  conditionsAPI,
  policyAPI,
} from "../../routes/apiURL";
import { createAsyncThunk } from "@reduxjs/toolkit";

// auth-sign-up
export const authSignUp = createAsyncThunk("auth-sign-up", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: signUpAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });

    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// auth-login
export const authLogin = createAsyncThunk("auth-login", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: loginAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });

    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// varify-otp
export const varifyOtp = createAsyncThunk("varify-otp", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: varifyOtpAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });

    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});
// auth-forgot-password
export const authForgotPassword = createAsyncThunk(
  "auth-forgot-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: forgotPasswordAPI,
        method: "POST",
        data: payload,
        isErrorToast: true,
      });

      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  },
);

// varify-forgot-password-otp
export const varifyForgotPassOtp = createAsyncThunk(
  "varify-forgot-password-otp",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: varifyForgotOtpAPI,
        method: "POST",
        data: payload,
        isErrorToast: true,
      });

      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  },
);
// reset-current-password
export const resetCurrentPassword = createAsyncThunk(
  "reset-current-password",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: resetCurrentPasswordAPI,
        method: "POST",
        data: payload,
        isErrorToast: true,
      });

      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  },
);

// resend-otp
export const resendOtp = createAsyncThunk("resend-otp", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: resendOtpAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });

    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// fetch-subscription
export const fetchSubscriptions = createAsyncThunk(
  "fetch-subscription",
  async () => {
    try {
      const response = await API_REQUEST({
        url: subscriptionsAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  },
);

// update-profile
export const updateProfile = createAsyncThunk(
  "update-profile",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: editProfileAPI,
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      callback(response);
      return response;
    } catch (error) {
      callback(null, error);
    }
  },
);

// fetch-profile
export const fetchProfile = createAsyncThunk("fetch-profile", async () => {
  try {
    const response = await API_REQUEST({
      url: profileAPI,
      method: "GET",
    });
    return response;
  } catch (error) {}
});

// fetch-faq
export const fetchFaq = createAsyncThunk("fetch-faq", async () => {
  try {
    const response = await API_REQUEST({
      url: faqAPI,
      method: "GET",
    });
    return response;
  } catch (error) {}
});
// fetch-policy
export const fetchPolicy = createAsyncThunk("fetch-policy", async (props) => {
  try {
    const response = await API_REQUEST({
      url: policyAPI,
      method: "POST",
      isSuccessToast:false,
      data: props,
    });
    return response;
  } catch (error) {}
});
// fetch-conditions
export const fetchConditions = createAsyncThunk(
  "fetch-conditions",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: conditionsAPI,
        method: "POST",
        isSuccessToast:false,
        data: props,
      });
      return response;
    } catch (error) {}
  },
);

// // auth-forgot-password
// export const authForgotPassword = createAsyncThunk(
//   "auth-forgot-password",
//   async (props) => {
//     const { payload, callback } = props;
//     try {
//       const response = await API_REQUEST({
//         url: forgotPasswordAPI,
//         method: "POST",
//         data: payload,
//         isErrorToast: true,
//       });
//       callback(response);
//       return response;
//     } catch (error) {
//       callback(null, error);
//     }
//   }
// );

// // fetch-profile
// export const fetchProfile = createAsyncThunk("fetch-profile", async () => {
//   try {
//     const response = await API_REQUEST({
//       url: profileAPI,
//       method: "GET",
//     });
//     return response;
//   } catch (error) { }
// });

// // update-profile
// export const updateProfile = createAsyncThunk(
//   "update-profile",
//   async (props) => {
//     const { payload, callback } = props;
//     try {
//       const response = await API_REQUEST({
//         url: profileUpdateAPI,
//         method: "POST",
//         data: payload,
//       });
//       callback(response);
//       return response;
//     } catch (error) {
//       callback(null, error);
//     }
//   }
// );
// // auth-change-password
// export const changePassword = createAsyncThunk(
//   "auth-change-password",
//   async (props) => {
//     const { payload, callback } = props;
//     try {
//       const response = await API_REQUEST({
//         url: changePasswordAPI,
//         method: "POST",
//         data: payload,
//       });
//       callback(response);
//       return response;
//     } catch (error) {
//       callback(null, error);
//     }
//   }
// );

// // Dashboard
// export const getDashboardData = createAsyncThunk("get-dashboard", async () => {
//   try {
//     const response = await API_REQUEST({
//       url: DashboardDataAPI,
//       method: "GET",
//     });
//     return response;
//   } catch (error) {
//     console.log(error);
//   }
// });
